import { render, staticRenderFns } from "./HowMuch.vue?vue&type=template&id=324141be&scoped=true&"
import script from "./HowMuch.vue?vue&type=script&lang=js&"
export * from "./HowMuch.vue?vue&type=script&lang=js&"
import style0 from "./HowMuch.vue?vue&type=style&index=0&id=324141be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324141be",
  null
  
)

export default component.exports